import { IMARPOLStore } from "../marpol/@types";
import { IGarbageEditLog, IGRB2 } from "./@types";

const grb2Helper = {
	getHistoryList(store: IMARPOLStore) {
		return store.docs.ids.map((id) => ({
			...(store.docs.byIds[id] as IGRB2),
			editHistory: grb2Helper.getGarbageRecordEditHistory(
				store.docs.byIds[id] as IGRB2
			),
		}));
	},
	getGarbageRecordEditHistory(grb2: IGRB2) {
		const uniqueFields = Object.keys(grb2.editLogs)
			.reduce<{ fieldName: string; fieldLabel: string }[]>(
				(result, editSessionNumber) => {
					const editedItems = grb2.editLogs[parseInt(editSessionNumber, 10)];
					return [
						...result,
						...editedItems.ids.map((itemId) => {
							return {
								fieldName: editedItems.byIds[itemId].fieldName,
								fieldLabel: editedItems.byIds[itemId].fieldLabel,
							};
						}),
					];
				},
				[]
			)
			.filter(
				(item, i, ar) =>
					ar.findIndex(
						(indexItem) => indexItem.fieldName === item.fieldName
					) === i
			);

		const editHistory = uniqueFields.map((field) => {
			return {
				...field,
				edits: Object.keys(grb2.editLogs).reduce<IGarbageEditLog[]>(
					(result, editSessionNumber) => {
						const editedItemsByIds =
							grb2.editLogs[parseInt(editSessionNumber, 10)].byIds;
						if (editedItemsByIds[field.fieldName])
							return [...result, editedItemsByIds[field.fieldName]];
						return result;
					},
					[]
				),
			};
		});
		return editHistory;
	},
	getEditHistoryForGarbage(grb2: IGRB2) {
		const uniqueFields = Object.keys(grb2.editLogs)
			.reduce<{ fieldName: string; fieldLabel: string }[]>(
				(result, editSessionNumber) => {
					const editedItems = grb2.editLogs[parseInt(editSessionNumber, 10)];
					return [
						...result,
						...editedItems.ids.map((itemId) => {
							return {
								fieldName: editedItems.byIds[itemId].fieldName,
								fieldLabel: editedItems.byIds[itemId].fieldLabel,
							};
						}),
					];
				},
				[]
			)
			.filter(
				(item, i, ar) =>
					ar.findIndex(
						(indexItem) => indexItem.fieldName === item.fieldName
					) === i
			);

		const editHistory = uniqueFields.map((field) => {
			return {
				...field,
				edits: Object.keys(grb2.editLogs).reduce<IGarbageEditLog[]>(
					(result, editSessionNumber) => {
						const editedItemsByIds =
							grb2.editLogs[parseInt(editSessionNumber, 10)].byIds;
						if (editedItemsByIds[field.fieldName])
							return [...result, editedItemsByIds[field.fieldName]];
						return result;
					},
					[]
				),
			};
		});
		return editHistory;
	},
};

export default grb2Helper;
